var picturesListenTo = [];
export default function () {
  const pictures = document.querySelectorAll('picture.picture-preview');
  const imageLoaded = function (event) {
    const image = event.target;
    image.removeAttribute('style');
    var picture = image.closest('picture.picture-preview');
    if (picture) {
      picture.classList.remove('picture-preview');
    }
  };
  for (let i = 0; i < pictures.length; i++) {
    const picture = pictures[i];
    if (picturesListenTo.indexOf(picture) >= 0) {
      continue;
    }
    picturesListenTo.push(picture);
    const image = picture.querySelector('img');
    if (!image) {
      continue;
    }
    if (image.complete) {
      imageLoaded({
        target: image
      });
    } else {
      image.addEventListener('error', imageLoaded);
      image.addEventListener('load', imageLoaded);
    }
  }
}